import { f7 } from 'framework7-react';
import { useEffect, useMemo, useRef, useState } from 'react';

interface PickerSelectHookProps {
  initialSelect: string;
  selectList: string[];
  pickerName: string;
}

export const usePickerSheet = ({
  initialSelect,
  selectList,
  pickerName,
}: PickerSelectHookProps) => {
  const pickerRef = useRef<any>(null);
  const [pickerSelect, setPickerSelect] = useState('');
  useEffect(() => {
    setPickerSelect(initialSelect);
  }, [initialSelect]);
  const pickerInputID = useMemo(
    () => `${pickerName}-picker-input`,
    [pickerName],
  );
  useEffect(() => {
    if (!pickerRef.current && selectList.length > 0) {
      pickerRef.current = f7.picker.create({
        inputEl: `#${pickerInputID}`,
        value: [pickerSelect],
        cssClass: 'modal-picker',
        sheetPush: true,
        on: {
          change: function (picker) {
            const [value] = picker.value as string[];
            setPickerSelect(value);
          },
        },
        cols: [
          {
            textAlign: 'center',
            values: selectList,
          },
        ],
      });
      return () => {
        if (pickerRef.current) {
          pickerRef.current.destroy();
          pickerRef.current = null;
        }
      };
    }
  }, [selectList, pickerSelect]);
  useEffect(() => {
    if (pickerRef.current) {
      pickerRef.current.setValue([pickerSelect]);
    }
  }, [pickerSelect]);
  return { pickerSelect, pickerInputID };
};
